import { useMutation, useQueryClient } from "@tanstack/react-query";
import CommentsAPI from "../../api/CommentsAPI";
import { getErrorMessage } from "../../../utils/GeneralUtils";

interface Props {
  commentID: string;
  comment: { RichText: string; PlainText: string };
  context: string;
  contextID: string;
  mentionedUsers: string[];
}

// For editing comments
export function useUpdateComment() {
  const client = useQueryClient();

  const updateComment = useMutation({
    mutationFn: ({ commentID, comment, mentionedUsers }: Props) =>
      CommentsAPI.editComment(commentID, comment, mentionedUsers),
    onSuccess: (_, { context, contextID }) => {
      // I worked on trying to implement the update with onMutate for 3 hours...
      // For some reason the comment doesn't update, EVEN with Structured cloning the entire cache.
      // Also, in the RQ devtools it showed it was updated, but the UI would not reflect until you hovered over the comment you edited.
      // ReactToComment / DeleteComment update the UI no problem.. That's why this is so weird to me. I even upgraded RQ library just in case
      // So invalidateQueries will do for now..
      client.invalidateQueries({ queryKey: ["comments", context, contextID] });
    },
    onError: (err) => {
      console.log(getErrorMessage(err));
    },
  });

  return {
    updateComment: updateComment.mutate,
  };
}
